export const en = {
    to_proceed: 'Right now, you only have access to search for tickets and hotels. To proceed with adding or booking them, you need to',
    create_trip: 'create a business trip request',
    wait_for_approval: 'wait for the approval',
};
